import { useState, useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { videoProgressState, seekToState } from '@/store'
import { useRouter } from 'next/router'
import api from '@/utils/api'
import { useSession } from 'next-auth/client'

const MAX_DELTA = 3

export default function useSaveLastPlayedTime({ video }) {
  const [session] = useSession()
  const [lastProgress, setLastProgress] = useState(video.lastProgress || 0)
  const [progress] = useRecoilState(videoProgressState)
  const [, setSeekTo] = useRecoilState(seekToState)
  const router = useRouter()
  const pathname = router.pathname
  const shouldRun = pathname === '/videos/[id]' && !video.finished

  useEffect(
    function seekToProgress() {
      const isOwnVideo = session && session.user._id === video.user

      if (shouldRun && isOwnVideo && video.lastProgress) {
        setSeekTo({ time: video.lastProgress, shouldPlay: false })
      }
    },
    [video._id, router]
  )

  useEffect(
    function markAsFinished() {
      if (!progress || !shouldRun) {
        return
      }

      const oneMinute = 60
      const currentProgress = progress.playedSeconds
      const delta = Math.abs(video.duration - currentProgress)

      if (delta <= oneMinute) {
        api.put(`/videos/${video._id}`, {
          lastProgress: video.duration,
          finished: true,
        })
        setLastProgress(currentProgress)
      }
    },
    [shouldRun, progress]
  )

  useEffect(
    function saveProgress() {
      if (!progress || !shouldRun) {
        return
      }

      const currentProgress = progress.playedSeconds

      if (currentProgress < 1) {
        return
      }

      const delta = Math.abs(currentProgress - lastProgress)

      if (delta >= MAX_DELTA) {
        api.put(`/videos/${video._id}`, {
          lastProgress: currentProgress,
        })
        setLastProgress(currentProgress)
      }
    },
    [progress, lastProgress, shouldRun]
  )
}
